import React from "react";
const Login = React.lazy(() =>
  import("../src/components/auth/login/Login")
);


const Dashboard_Analytics = React.lazy(() =>
  import("../src/components/header_components/dashboard_analytics/Dashboard_Analytics")
);

const Sample_Management = React.lazy(() =>
  import("../src/components/header_components/sample_management/Sample_Management")
);

const Instrument_Management = React.lazy(() =>
  import("../src/components/header_components/instrument_management/Instrument_Management")
);

const Consumable_Item = React.lazy(() =>
  import("../src/components/header_components/instrument_management/consumable_item/Consumable_Item")
);

const Certificate_Generation = React.lazy(() =>
  import("../src/components/header_components/certificate_generation/Certificate_Generation")
);

const Customer_Management = React.lazy(() =>
  import("../src/components/header_components/customer_management/Customer_Management")
);

const Customer_Download_Page = React.lazy(() =>
  import("../src/components/header_components/customer_management/customer_download_page/Customer_Download_Page")
);

const Quality_Management = React.lazy(() =>
  import("../src/components/header_components/quality_management/Quality_Management")
);

const Audit_Traceability_Logs = React.lazy(() =>
  import("../src/components/header_components/audit_traceability_logs/Audit_Traceability_Logs")
);

const User_Management = React.lazy(() =>
  import("../src/components/header_components/user_management_page/User_Management_Page")
);



// const Imperiality = React.lazy(() =>
//   import("../src/components/header_components/quality_management/general_requirement/imperiality/Imperiality")
// );

const routes = [

   { path: "/login", exact: true, name: "login", element: Login },

  { path: "/", exact: true, name: "Dashboard Analytics", element: Dashboard_Analytics },


  { path: "/sample-management", exact: true, name: "Sample Management", element: Sample_Management },

  
  { path: "/instrument-management", exact: true, name: "Instrument_Management", element: Instrument_Management },

  
  { path: "/instrument-management/consumable-item", exact: true, name: "Consumable_Item", element: Consumable_Item },


  { path: "/certificate-generation", exact: true, name: "Certificate_Generation", element: Certificate_Generation },

 
  { path: "/customer-management", exact: true, name: "Customer_Management", element: Customer_Management },
  { path: "/customer-download", element: Customer_Download_Page },

 
   { path: "/quality-management", exact: true, name: "Quality_Management", element: Quality_Management },

   { path: "/audit-traceability-logs", exact: true, name: "Audit_Traceability_Logs", element: Audit_Traceability_Logs },

   { path: "/user-management", exact: true, name: "User_Management", element: User_Management },

  
];

export default routes;
